// :cow: Cosmose CONFIDENTIAL :iso:
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { interval, Subject } from 'rxjs';
import { delay, filter, map, take, takeUntil, tap } from 'rxjs/operators';
import { Step } from '@med/app/home/demo/guided-tour/models/step';
import { GuidedTourService } from '@med/app/home/demo/guided-tour/services/guided-tour.service';
import { selectStep } from '@med/app/home/demo/guided-tour/store/guided-tour.selectors';
import { animate, style, transition, trigger } from '@angular/animations';
import { NgClass } from '@angular/common';
import { GuidedTourSkeletonComponent } from './components/guided-tour-skeleton/guided-tour-skeleton.component';
import { PortalComponent } from './components/portal/portal.component';
import { ExposedElementComponent } from './components/exposed-element/exposed-element.component';
import { GuidedTourDialogComponent } from './components/guided-tour-dialog/guided-tour-dialog.component';


@Component({
  selector: 'e-guided-tour-2',
  templateUrl: './guided-tour.component.html',
  styleUrls: ['./guided-tour.component.scss'],
  animations: [
    trigger('fadeOut', [
      transition('* => void', [
        style({opacity: 1}),
        animate(500, style({opacity: 0})),
      ]),
    ]),
  ],
  imports: [
    GuidedTourSkeletonComponent,
    PortalComponent,
    ExposedElementComponent,
    GuidedTourDialogComponent,
    NgClass,
  ],
})
export class GuidedTourComponent implements OnDestroy, AfterViewInit {

  step: Step;
  showSkeleton: boolean;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private store: Store,
    private cdr: ChangeDetectorRef,
    private guidedTourService: GuidedTourService,
  ) {
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngAfterViewInit(): void {
    this.watchStep();
  }

  onExitDemoClick(): void {
    this.guidedTourService.emitExitDemoClick();
  }

  onNextStepClick(): void {
    this.guidedTourService.emitNextStepClick();
  }

  onExposedElementClick(): void {
    this.guidedTourService.emitPortalClick();
  }

  private watchStep(): void {
    this.store.pipe(
      select(selectStep),
      filter(v => v != null),
      tap((step) => {
        this.showSkeleton = !!step.portal;
        this.cdr.detectChanges();
      }),
      delay(100),
      takeUntil(this.unsubscribe$),
    ).subscribe(step => {
      this.step = step;
      this.waitForPortal();
    });
  }

  private waitForPortal(): void {
    if (!this.step?.portal) {
      return;
    }

    interval(500).pipe(
      map(() => document.querySelector(this.step.portal.selector)),
      filter(v => v != null),
      takeUntil(this.unsubscribe$),
      take(1),
    ).subscribe(() => {
      this.showSkeleton = false;
    });
  }
}
